/**
 * Normalize public/data/playlist.json into player-ready track rows.
 */
export const normalizePlaylist = (raw) => {
  const tracks = (raw?.tracks ?? []).map((track) => {
    const artist = Array.isArray(track.artists)
      ? track.artists.join(', ')
      : String(track.artists ?? '')

    return {
      id: track.id ?? `${track.name}-${artist}`,
      title: track.name ?? '',
      artist,
      previewUrl: track.previewUrl ?? null,
      itunesTrackId: track.itunesTrackId ?? null,
      spotifyUrl: track.spotifyUrl ?? null,
      hasPreview: Boolean(track.previewUrl),
    }
  })

  return {
    title: raw?.name ?? 'Website',
    spotifyUrl: raw?.playlistUrl ?? raw?.spotifyUrl ?? '',
    updated: raw?.updated ?? raw?.itunesResolvedAt ?? null,
    tracks,
  }
}

export const fetchWebsitePlaylist = async () => {
  const response = await fetch('/data/playlist.json', { cache: 'no-store' })
  if (!response.ok) {
    throw new Error(`Failed to load playlist (${response.status})`)
  }

  const raw = await response.json()
  return normalizePlaylist(raw)
}
